import React from "react";
import cx from "classnames";
import Icon from "components/CommonIcon/Icon";

export const MenuOption = ({ children, selected, onClick }) => {
  return (
    <div
      className=" flex items-center justify-between border-b border-gray-light py-12"
      onClick={onClick}>
      <span
        className={cx("font-mulish text-14-24 text-gray-text", {
          "font-bold": selected,
        })}>
        {children}
      </span>
      {selected && (
        <span className="pr-20 ml-auto">
          <Icon name="tick" color="text-blue-ayana" fontSize="text-12" />
        </span>
      )}
    </div>
  );
};

export const MenuOptionsList = ({ children }) => (
  <div className="pt-20 pl-20">{children}</div>
);
